<form (ngSubmit)="applyChanges()" [formGroup]="range">
  <h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.COMMON.DATES.DATE_RANGE' | translate }}</h2>
  <div mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-date-range-input [formGroup]="range" [max]="maxDate" [min]="minDate" [rangePicker]="picker">
        <input formControlName="start" matStartDate placeholder="Start date" />
        <input formControlName="end" matEndDate placeholder="End date" />
      </mat-date-range-input>
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      <mat-error *ngIf="range.invalid">
        {{ 'FRONTEND.SALES_UI.COMMON.DATES.INVALID_DATE_RANGE' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button color="primary" mat-raised-button type="submit">
      {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.APPLY' | translate }}
    </button>
  </div>
</form>
